import React from "react";

const ImageScroller = ({ images }) => {
  if (!Array.isArray(images) || images.length === 0) return null;

  return (
    <div className="quality-images-scroll-horizontal">
      {images.map((item, index) => (
        <div className="q-img-horizontal" key={index}>
          <img src={item.image} alt={`img-${index}`} className="q-img" />
          {item.label && (
            <p className="q-img-label">{item.label}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default ImageScroller;
